@if (isCollapsed) {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="toggleCollapsed()"
        [id]="'toggleCollapseButton-' + consequence?.PatientBehaviorConsequence"
      >
        {{ consequence?.PatientBehaviorConsequence }}
      </button>
    </div>

    @if (consequence?.IsDeleted) {
    <div class="col-2">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" />
    </div>
    }

    <div class="col-1">
      <i
        class="pi pi-arrow-down pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapsed()"
      ></i>
    </div>
  </div>
</div>
} @else {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="toggleCollapsed()"
        [id]="'toggleCollapseButton-' + consequence?.PatientBehaviorConsequence"
      >
        {{ consequence?.PatientBehaviorConsequence }}
      </button>
    </div>

    @if (consequence?.IsDeleted) {
    <div class="col-2">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" />
    </div>
    }

    <div class="col-1">
      <i
        class="pi pi-arrow-up pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapsed()"
      ></i>
    </div>
  </div>

  <div class="row" id="consequenceActions">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <button
          (click)="editConsequence()"
          [disabled]="consequence?.IsDeleted"
          [style.opacity]="consequence?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="consequence?.IsDeleted ? 'not-allowed' : 'pointer'"
          class="side-menu-button2 flex-grow-1 mx-2"
          [id]="
            'editConsequenceButton-' + consequence?.PatientBehaviorConsequence
          "
        >
          Edit Consequence
        </button>
        @if (!consequence?.IsDeleted) {
          <button
          (click)="deleteConsequence()"
          [style.opacity]="'1'"
          class="switch-mode-button flex-grow-1 mx-2"
          [id]="'deleteConsequenceButton-' + consequence?.PatientBehaviorConsequence"
        >
          Delete Consequence
        </button>
        }
        @else{
          <button
          (click)="restoreConsequence()"
          [style.opacity]="'1'"
          class="side-menu-button2 flex-grow-1 mx-2"
          [id]="'restoreConsequenceButton-' + consequence?.PatientBehaviorConsequence"
        >
          Restore Consequence
        </button>
        }
      </div>
    </div>
  </div>
</div>
}
